import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Row, Col, UncontrolledPopover, PopoverBody, Button } from "reactstrap";

import axios from "axios";

//QueueAttendence child components
import Status from "./subcomponents/Status";
import Search from "./subcomponents/Search";
import FilterDate from "../FilterConversations/FilterDate";
import "./subcomponents/AgentStatusView.scss";

//i18n
import { withTranslation } from "react-i18next";

import { isArray } from "../../../../Libs/CustomMethods/customMethods";
import ButtonTicketList from "./subcomponents/ButtonTicketList";

const QueueAttendance = ({
  t,
  update,
  overdue,
  progress,
  inactive,
  closed,
  onChangeFilter,
  onChangeSearch,
  isSpy,
  resetActiveChat,
}) => {
  const features = useSelector((state) => state?.Login?.data?.features);
  const isFeatureQueueCounter = features?.find(
    (e) => e.name === "Agent area information"
  )?.active
    ? features?.find((e) => e.name === "Agent area information")?.config
        ?.queue_counter
    : false;

  const isFeatureAgentsStatusView = features?.find(
    (e) => e.name === "Agent area information"
  )?.active
    ? features?.find((e) => e.name === "Agent area information")?.config
        ?.agents_status_view
    : false;

  const isFeatureConversationFilter = features?.find(
    (e) => e.name === "Conversation Filter"
  )?.active;

  const [queueCounter, setQueueCounter] = useState({ data: [], counter: 0 });
  const [agentsStatusView, setAgentStatusView] = useState({
    data: [],
    total: 0,
  });
  const [selectedStatusInfo, setSelectedStatusInfo] = useState({
    online: false,
    backsoon: false,
    away: false,
  });

  const styleStatusInfo = {
    classNameDiv:
      "p-2 rounded border pointer d-flex align-items-center status-item",
    classOnline: "bx bxs-check-circle text-success mr-1",
    classBacksoon: "bx bxs-time-five text-warning mr-1",
    classAway: "bx bxs-minus-circle text-danger mr-1",
  };

  const getQueue = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/manager-panel-queue-attendance-summary`
      );
      if (response.status === 200) {
        const counter = response.data?.listOfSkills.reduce(
          (acc, cur) => acc + cur?.on_queue_number,
          0
        );
        setQueueCounter((prev) => ({
          ...prev,
          data: response.data?.listOfSkills,
          counter,
        }));
      } else {
        throw response.data;
      }
    } catch (error) {}
  };

  const getAgentsStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/agents-status-info`
      );
      if (response.status === 200) {
        setAgentStatusView((prev) => ({
          ...prev,
          data: response.data?.skills,
          total: response.data?.total,
        }));
      } else {
        throw response.data;
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (isFeatureQueueCounter) {
      const interval = setInterval(() => getQueue(), 60000);
      return () => clearInterval(interval);
    }
  }, [isFeatureQueueCounter]);

  useEffect(() => {
    if (isFeatureAgentsStatusView) {
      const interval = setInterval(() => getAgentsStatus(), 60000);
      return () => clearInterval(interval);
    }
  }, [isFeatureAgentsStatusView]);

  useEffect(() => {
    getQueue();
    getAgentsStatus();
  }, [update]);

  return (
    <>
      {isFeatureQueueCounter && (
        <div className="d-flex justify-content-between mt-4 pb-4 border-bottom">
          <div className="d-flex align-self-center">
            <h5>{t("Attendance Queue")}</h5>
          </div>
          <div className="d-flex">
            <div className="p-2 rounded border pointer" id="counterTootip">
              <div>{queueCounter.counter}</div>
            </div>
            {queueCounter?.data?.length > 0 && (
              <UncontrolledPopover placement="bottom" target="counterTootip">
                <PopoverBody className="d-inline-block skills-tooltip ">
                  {isArray(queueCounter.data) &&
                    queueCounter.data.map((el, key) => (
                      <div className="px-1 mb-1 rounded border" key={key}>
                        <div className=" font-size-12 font-weight-bold">
                          {el?.on_queue_number}
                        </div>
                        <div className="font-size-12">{el?.queue}</div>
                      </div>
                    ))}
                </PopoverBody>
              </UncontrolledPopover>
            )}
          </div>
        </div>
      )}
      {isFeatureAgentsStatusView && (
        <div className="d-flex justify-content-between mt-4 pb-4 border-bottom">
          <div className="d-flex align-self-center">
            <h5>{t("Agents Status")}</h5>
          </div>
          <div className="d-flex">
            <div
              className={
                styleStatusInfo.classNameDiv +
                `${selectedStatusInfo.online ? " selected-status" : ""} `
              }
              id="onlineTooltip"
              onClick={(e) => {
                e.preventDefault();
                setSelectedStatusInfo((prev) => ({
                  ...prev,
                  online:
                    agentsStatusView?.total?.online > 0
                      ? !selectedStatusInfo.online
                      : false,
                }));
              }}
            >
              <i className={styleStatusInfo.classOnline}></i>
              <div>{agentsStatusView?.total?.online}</div>
            </div>

            <div
              className={
                styleStatusInfo.classNameDiv +
                `${selectedStatusInfo.backsoon ? " selected-status" : ""} `
              }
              id="backsoonTooltip"
              onClick={(e) => {
                e.preventDefault();
                setSelectedStatusInfo((prev) => ({
                  ...prev,
                  backsoon:
                    agentsStatusView?.total?.backsoon > 0
                      ? !selectedStatusInfo.backsoon
                      : false,
                }));
              }}
            >
              <i className={styleStatusInfo.classBacksoon}></i>
              <div>{agentsStatusView?.total?.backsoon}</div>
            </div>

            <div
              className={
                styleStatusInfo.classNameDiv +
                `${selectedStatusInfo.away ? " selected-status" : ""} `
              }
              id="awayTooltip"
              onClick={(e) => {
                e.preventDefault();
                setSelectedStatusInfo((prev) => ({
                  ...prev,
                  away:
                    agentsStatusView?.total?.away > 0
                      ? !selectedStatusInfo.away
                      : false,
                }));
              }}
            >
              <i className={styleStatusInfo.classAway}></i>
              <div>{agentsStatusView?.total?.away}</div>
            </div>

            {agentsStatusView?.total?.online > 0 && (
              <UncontrolledPopover
                placement="left"
                target="onlineTooltip"
                trigger="click"
              >
                <PopoverBody className="d-inline-block skills-tooltip">
                  {agentsStatusView?.data &&
                    agentsStatusView?.data
                      ?.filter((skill) => skill?.agents?.online > 0)
                      .map((el, key) => (
                        <div className="px-1 mb-1 rounded border" key={key}>
                          <div className="font-weight-bold">
                            {el?.agents?.online}
                          </div>
                          <div>{el?.name}</div>
                        </div>
                      ))}
                </PopoverBody>
              </UncontrolledPopover>
            )}
            {agentsStatusView?.total?.backsoon > 0 && (
              <UncontrolledPopover
                placement="bottom"
                target="backsoonTooltip"
                trigger="click"
              >
                <PopoverBody className="d-inline-block skills-tooltip">
                  {agentsStatusView?.data &&
                    agentsStatusView?.data
                      ?.filter((skill) => skill?.agents?.backsoon > 0)
                      .map((el, key) => (
                        <div className="px-1 mb-1 rounded border" key={key}>
                          <div className="font-weight-bold">
                            {el?.agents?.backsoon}
                          </div>
                          <div>{el?.name}</div>
                        </div>
                      ))}
                </PopoverBody>
              </UncontrolledPopover>
            )}
            {agentsStatusView?.total?.away > 0 && (
              <UncontrolledPopover
                placement="right"
                target="awayTooltip"
                trigger="click"
              >
                <PopoverBody className="d-inline-block skills-tooltip">
                  {agentsStatusView?.data &&
                    agentsStatusView?.data
                      ?.filter((skill) => skill?.agents?.away > 0)
                      .map((el, key) => (
                        <div className="px-1 mb-1 rounded border" key={key}>
                          <div className="font-weight-bold">
                            {el?.agents?.away}
                          </div>
                          <div>{el?.name}</div>
                        </div>
                      ))}
                </PopoverBody>
              </UncontrolledPopover>
            )}
          </div>
        </div>
      )}
      <Row>
        <ButtonTicketList isSpy={isSpy} resetActiveChat={resetActiveChat} />
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col lg="12">
          <div className="chat-leftsidebar-nav justify-content-between">
            {/* Here we've 4 buttons representing the states os conversations */}
            <Status
              overcome={overdue}
              progress={progress}
              inactive={inactive}
              closed={closed}
              onChangeFilter={onChangeFilter}
            />

            {/* Area of search area, between status and queue */}
            <div
              style={{
                marginTop: "15px",
                marginBottom: "15px",
                display: "flex",
              }}
            >
              <Search
                onChangeSearch={onChangeSearch}
                placeholder={`${t("Search")}...`}
              />
              {isFeatureConversationFilter && <FilterDate />}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default withTranslation()(QueueAttendance);
